
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31027",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31027",
  "emoji-mart": "static-3.7",
  "feedback-schema": "static-1.55614",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8519",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11968",
  "I18n": "static-7.1708",
  "quartz": "static-1.7664",
  "quartz-config": "static-1.1442",
  "quartz-core": "static-1.6883",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1103",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55601",
  "feedback-utils": "static-1.55605",
  "forms-embed-utils-lib": "static-1.4941",
  "forms-utils-lib": "static-1.13347",
  "foundations-assets": "static-1.5367",
  "foundations-components": "static-1.8758",
  "foundations-theming": "static-1.4969",
  "hub-http": "static-1.6687",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12275",
  "icons": "static-2.703",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4234",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17218",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5659",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.518",
  "tinymce-plugins": "static-1.58521",
  "transmute": "static-2.97",
  "ui-images": "static-2.1277",
  "UIComponents": "static-3.8914",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3941",
  "quartz-webpack": "static-1.3888",
  "foundations-theming-specialty": "static-1.2685",
  "property-description-translator": "static-1.4300",
  "HeadJS": "static-2.822",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3630",
  "msw": "static-1.103",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4788",
  "jasmine-runner": "static-1.6933",
  "opentelemetry-fe-types": "static-1.272",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4978",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.647",
  "quartz-auth": "static-1.1339",
  "quartz-head": "static-1.1329",
  "quartz-i18n": "static-1.1339",
  "quartz-routing": "static-1.1094",
  "quartz-test": "static-1.1339",
  "quartz-tracking": "static-1.1043",
  "trellis-components": "static-1.3121",
  "ui-fonts": "static-1.1230",
  "usage-tracker-container": "static-1.7795",
  "usage-tracker-core": "static-1.7655",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.369",
  "conversations-skeleton-state": "static-1.7608",
  "reference-resolvers": "static-1.8664",
  "sanitize-text": "static-1.8639",
  "PatternValidationJS": "static-1.3365",
  "ReduxMessenger": "static-2.10851",
  "outpost": "static-1.4609",
  "rpc-client-utils": "static-1.5150",
  "sanitize": "static-1.4955",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5027",
  "floating-ui": "static-1.68",
  "hs-story-utils": "static-1.9908",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.103",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3102",
  "bend-plugin-foundations-theming": "static-1.3452",
  "foundations-theming-base": "static-1.3954",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.403",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.181",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.10034",
  "atom": "static-1.5553",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8431",
  "ContentUtils": "static-1.69487",
  "data-token-picker": "static-1.17144",
  "file-manager-components": "static-1.24857",
  "FileManagerCore": "static-1.40356",
  "FileManagerLib": "static-1.40497",
  "frontend-preferences-client": "static-1.8401",
  "hub-http-contrib": "static-1.3513",
  "interframe": "static-3.5222",
  "layout-dnd-components": "static-1.13238",
  "layout-dnd-utils": "static-1.12213",
  "property-translator": "static-1.5860",
  "react-codemirror": "static-1.11122",
  "react-colorpicker": "static-2.10690",
  "reference-resolvers-lite": "static-1.8593",
  "rich-text-lib": "static-1.20564",
  "tinymce-data": "static-1.41492",
  "tinymce-themes": "static-1.57377",
  "ui-addon-emoji-picker": "static-1.10344",
  "ui-addon-sales-email": "static-1.5682",
  "ui-brand-identity-lib": "static-1.16965",
  "bender-build-tools": "static-1.3600",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10916",
  "hubspotter-http-shared-msw-handlers": "static-1.10914",
  "usage-tracker-session-replay": "static-1.5491",
  "base-ui": "static-1.28",
  "react-day-picker": "static-1.15",
  "trellis-theming": "static-1.1488",
  "tanstack-virtual": "static-1.43",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.560",
  "chirp-fetch": "static-1.2385",
  "stylex-utils": "static-1.175",
  "chatspot-core": "static-1.23917",
  "copilot-toolkit": "static-1.12162",
  "customer-data-objects-ui-components": "static-1.13516",
  "data-fetching-client": "static-1.10121",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5240",
  "ui-addon-video-player": "static-1.9104",
  "ui-coaching-tips": "static-1.29589",
  "usage-tracker": "static-1.7805",
  "cms-field-types": "static-1.5291",
  "content-icons-ui": "static-1.2462",
  "integrations-lib": "static-1.17443",
  "customer-data-objects": "static-1.8186",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2204",
  "apollo-link-hub-http": "static-2.5068",
  "apollo-stack-hubspot": "static-3.99",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4622",
  "poll-commands": "static-1.3958",
  "ui-addon-iframeable": "static-1.9556",
  "video-components-external": "static-1.12445",
  "video-data-lib": "static-1.36103",
  "audio-components": "static-1.6581",
  "breeze-artifacts-sdk": "static-1.982",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30071",
  "FileManagerImages": "static-1.38008",
  "foundations-components-legacy": "static-1.1783",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.738",
  "ui-universal-auth": "static-1.9757",
  "urlinator": "static-1.4995",
  "video-components": "static-1.14447",
  "video-embed": "static-1.36937",
  "ts-schema": "static-1.4397",
  "ContentData": "static-1.69562",
  "layout-data-lib": "static-1.10538",
  "react-dnd-compat": "static-1.5090",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2029",
  "external-options-client-types": "static-1.4442",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6073",
  "hs-resources": "static-1.667",
  "inbound-db-properties-service-client": "static-1.4154",
  "NamespacedHubStyle": "static-2.9370",
  "growth-onboarding-confetti": "static-1.3539",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11626",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5911",
  "magpie-types": "static-1.5371",
  "simple-logging-lib": "static-1.3532",
  "avatar-components": "static-1.2966",
  "customer-data-ui-utilities": "static-1.10312",
  "growth-onboarding-feedback-components": "static-1.7061",
  "flux-actions": "static-1.381",
  "hubspot-apollo-client": "static-1.5363",
  "integrations-error-boundary-lib": "static-1.14858",
  "integrations-tracking-lib": "static-1.6101",
  "laboratory-lib": "static-3.7627",
  "native-integrations-shared-strings": "static-1.8244",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10759",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1182",
  "breeze-engine-core": "static-1.1482",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1128",
  "navigation-messaging": "static-1.8506",
  "content-media-composition-data-lib": "static-1.13611",
  "content-media-compositions": "static-2.17618",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19651",
  "nudge-client-utils": "static-1.3431",
  "custom-vendor-connection-lib": "static-1.321",
  "unified-auth-core-lib": "static-1.1553",
  "social-insights-client-types": "static-1.22942",
  "advanced-menus-core": "static-1.15825",
  "advanced-menus-lib": "static-1.12576",
  "ExportDialog": "static-6.10854",
  "ui-memberships-settings-lib": "static-1.35208",
  "conditional-properties-service-client": "static-1.4116",
  "crm-pipelines-api-client-types": "static-1.4446",
  "event-emitter": "static-1.1442",
  "fdsr-migration-layer": "static-1.492",
  "framework-builder-read-service-client": "static-1.4338",
  "inbound-db-meta-service-client": "static-1.3777",
  "multi-currency-client-types": "static-1.4010",
  "foundations-components-test-utils": "static-1.6241",
  "reactive-lib": "static-1.1200",
  "trellis-migration-context": "static-1.61",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.822",
  "universal-page-editor-lib": "static-1.3493",
  "bend-plugin-pulse": "static-1.631",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30816",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3188",
  "nudge-renderer-utils": "static-1.3507",
  "onboarding-tours": "static-1.17410",
  "whisper-core-api": "static-1.7648",
  "fsm": "static-1.4238",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15824",
  "simple-menus-lib": "static-1.17341",
  "settings-ui-lib": "static-1.13008",
  "persist-promise": "static-1.4186",
  "crm-record-cards-client": "static-1.69",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7373",
  "location-customization-utils-lib": "static-1.10433",
  "getting-started-shared-tasks": "static-1.19576",
  "growth-data-modal": "static-1.6143",
  "growth-onboarding-next-action-utils": "static-1.2996",
  "navigation-components": "static-1.19179",
  "nest": "static-1.716",
  "onboarding-tours-client": "static-1.5625",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-tracker": "static-1.8140",
  "user-context": "static-1.5534",
  "react-flip-move": "static-1.83",
  "framework-data-schema-quick-fetch": "static-1.7278",
  "onboarding-data-sync-lib": "static-1.2849",
  "growth-onboarding-next-action-components": "static-1.3024",
  "user-context-client": "static-1.4990",
  "getting-started-shared-tasks-store": "static-1.18694",
  "InboxConnectUtils": "static-4.15855",
  "meetings-connect-utils-lib": "static-1.8099",
  "onboarding-scopes": "static-1.6933"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31027",
  "emoji-mart": "/emoji-mart/static-3.7",
  "feedback-schema": "/feedback-schema/static-1.55614",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8519",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11968",
  "I18n": "/I18n/static-7.1708",
  "quartz": "/quartz/static-1.7664",
  "quartz-config": "/quartz-config/static-1.1442",
  "quartz-core": "/quartz-core/static-1.6883",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1103",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55601",
  "feedback-utils": "/feedback-utils/static-1.55605",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4941",
  "forms-utils-lib": "/forms-utils-lib/static-1.13347",
  "foundations-assets": "/foundations-assets/static-1.5367",
  "foundations-components": "/foundations-components/static-1.8758",
  "foundations-theming": "/foundations-theming/static-1.4969",
  "hub-http": "/hub-http/static-1.6687",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12275",
  "icons": "/icons/static-2.703",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4234",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17218",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5659",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tinymce-plugins": "/tinymce-plugins/static-1.58521",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1277",
  "UIComponents": "/UIComponents/static-3.8914",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3941",
  "quartz-webpack": "/quartz-webpack/static-1.3888",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2685",
  "property-description-translator": "/property-description-translator/static-1.4300",
  "HeadJS": "/HeadJS/static-2.822",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3630",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4788",
  "jasmine-runner": "/jasmine-runner/static-1.6933",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.272",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4978",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.647",
  "quartz-auth": "/quartz-auth/static-1.1339",
  "quartz-head": "/quartz-head/static-1.1329",
  "quartz-i18n": "/quartz-i18n/static-1.1339",
  "quartz-routing": "/quartz-routing/static-1.1094",
  "quartz-test": "/quartz-test/static-1.1339",
  "quartz-tracking": "/quartz-tracking/static-1.1043",
  "trellis-components": "/trellis-components/static-1.3121",
  "ui-fonts": "/ui-fonts/static-1.1230",
  "usage-tracker-container": "/usage-tracker-container/static-1.7795",
  "usage-tracker-core": "/usage-tracker-core/static-1.7655",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.369",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "reference-resolvers": "/reference-resolvers/static-1.8664",
  "sanitize-text": "/sanitize-text/static-1.8639",
  "PatternValidationJS": "/PatternValidationJS/static-1.3365",
  "ReduxMessenger": "/ReduxMessenger/static-2.10851",
  "outpost": "/outpost/static-1.4609",
  "rpc-client-utils": "/rpc-client-utils/static-1.5150",
  "sanitize": "/sanitize/static-1.4955",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5027",
  "floating-ui": "/floating-ui/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9908",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3102",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3452",
  "foundations-theming-base": "/foundations-theming-base/static-1.3954",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.403",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.181",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10034",
  "atom": "/atom/static-1.5553",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8431",
  "ContentUtils": "/ContentUtils/static-1.69487",
  "data-token-picker": "/data-token-picker/static-1.17144",
  "file-manager-components": "/file-manager-components/static-1.24857",
  "FileManagerCore": "/FileManagerCore/static-1.40356",
  "FileManagerLib": "/FileManagerLib/static-1.40497",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8401",
  "hub-http-contrib": "/hub-http-contrib/static-1.3513",
  "interframe": "/interframe/static-3.5222",
  "layout-dnd-components": "/layout-dnd-components/static-1.13238",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12213",
  "property-translator": "/property-translator/static-1.5860",
  "react-codemirror": "/react-codemirror/static-1.11122",
  "react-colorpicker": "/react-colorpicker/static-2.10690",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8593",
  "rich-text-lib": "/rich-text-lib/static-1.20564",
  "tinymce-data": "/tinymce-data/static-1.41492",
  "tinymce-themes": "/tinymce-themes/static-1.57377",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10344",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5682",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16965",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10916",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10914",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5491",
  "base-ui": "/base-ui/static-1.28",
  "react-day-picker": "/react-day-picker/static-1.15",
  "trellis-theming": "/trellis-theming/static-1.1488",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.560",
  "chirp-fetch": "/chirp-fetch/static-1.2385",
  "stylex-utils": "/stylex-utils/static-1.175",
  "chatspot-core": "/chatspot-core/static-1.23917",
  "copilot-toolkit": "/copilot-toolkit/static-1.12162",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13516",
  "data-fetching-client": "/data-fetching-client/static-1.10121",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5240",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9104",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29589",
  "usage-tracker": "/usage-tracker/static-1.7805",
  "cms-field-types": "/cms-field-types/static-1.5291",
  "content-icons-ui": "/content-icons-ui/static-1.2462",
  "integrations-lib": "/integrations-lib/static-1.17443",
  "customer-data-objects": "/customer-data-objects/static-1.8186",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2204",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5068",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4622",
  "poll-commands": "/poll-commands/static-1.3958",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9556",
  "video-components-external": "/video-components-external/static-1.12445",
  "video-data-lib": "/video-data-lib/static-1.36103",
  "audio-components": "/audio-components/static-1.6581",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.982",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30071",
  "FileManagerImages": "/FileManagerImages/static-1.38008",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1783",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.738",
  "ui-universal-auth": "/ui-universal-auth/static-1.9757",
  "urlinator": "/urlinator/static-1.4995",
  "video-components": "/video-components/static-1.14447",
  "video-embed": "/video-embed/static-1.36937",
  "ts-schema": "/ts-schema/static-1.4397",
  "ContentData": "/ContentData/static-1.69562",
  "layout-data-lib": "/layout-data-lib/static-1.10538",
  "react-dnd-compat": "/react-dnd-compat/static-1.5090",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2029",
  "external-options-client-types": "/external-options-client-types/static-1.4442",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6073",
  "hs-resources": "/hs-resources/static-1.667",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4154",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9370",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3539",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11626",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5911",
  "magpie-types": "/magpie-types/static-1.5371",
  "simple-logging-lib": "/simple-logging-lib/static-1.3532",
  "avatar-components": "/avatar-components/static-1.2966",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10312",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7061",
  "flux-actions": "/flux-actions/static-1.381",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5363",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14858",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6101",
  "laboratory-lib": "/laboratory-lib/static-3.7627",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8244",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10759",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1182",
  "breeze-engine-core": "/breeze-engine-core/static-1.1482",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1128",
  "navigation-messaging": "/navigation-messaging/static-1.8506",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13611",
  "content-media-compositions": "/content-media-compositions/static-2.17618",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19651",
  "nudge-client-utils": "/nudge-client-utils/static-1.3431",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.321",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1553",
  "social-insights-client-types": "/social-insights-client-types/static-1.22942",
  "advanced-menus-core": "/advanced-menus-core/static-1.15825",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12576",
  "ExportDialog": "/ExportDialog/static-6.10854",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35208",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4116",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4446",
  "event-emitter": "/event-emitter/static-1.1442",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.492",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4338",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3777",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4010",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6241",
  "reactive-lib": "/reactive-lib/static-1.1200",
  "trellis-migration-context": "/trellis-migration-context/static-1.61",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.822",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3493",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.631",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30816",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3188",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3507",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "whisper-core-api": "/whisper-core-api/static-1.7648",
  "fsm": "/fsm/static-1.4238",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15824",
  "simple-menus-lib": "/simple-menus-lib/static-1.17341",
  "settings-ui-lib": "/settings-ui-lib/static-1.13008",
  "persist-promise": "/persist-promise/static-1.4186",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.69",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7373",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10433",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19576",
  "growth-data-modal": "/growth-data-modal/static-1.6143",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2996",
  "navigation-components": "/navigation-components/static-1.19179",
  "nest": "/nest/static-1.716",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8140",
  "user-context": "/user-context/static-1.5534",
  "react-flip-move": "/react-flip-move/static-1.83",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7278",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2849",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3024",
  "user-context-client": "/user-context-client/static-1.4990",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18694",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15855",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8099",
  "onboarding-scopes": "/onboarding-scopes/static-1.6933"
}
};
